import { create } from 'zustand'

// Live status of print jobs created by the export-plan flow. Kept in zustand
// — not component state — so it survives whichever component started the
// export (e.g. the export modal) unmounting: use-export-plan-status-tracker
// reads/writes this via getState()/setState() from a plain setTimeout loop,
// independent of React's render cycle.
//
// jobs: { [jobId]: { planName, fileName, progress, downloadLink?, error? } }
export const useExportPlanStatusStore = create((set, get) => ({
  jobs: {},

  isTracked: (jobId) => jobId in get().jobs,

  setJobStatus: (jobId, status) =>
    set((state) => ({
      jobs: { ...state.jobs, [jobId]: status }
    })),

  removeJob: (jobId) =>
    set((state) => {
      const { [jobId]: _removed, ...jobs } = state.jobs
      return { jobs }
    })
}))

// Reactive selector for a single job's live status — e.g. a component that
// wants to show inline progress for an export it started.
export const useExportPlanJobStatus = (jobId) =>
  useExportPlanStatusStore((state) => (jobId ? state.jobs[jobId] : undefined))
